import { Injectable } from '@angular/core';
//import { GlobalConstants } from 'src/app/common/global-constants';
import { FaQModel } from '../models/faq.model';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import * as _ from 'lodash';
import { UserService } from './user.service';

@Injectable({
  providedIn: 'root'
})
export class FaqService {
  //readonly BaseURI = GlobalConstants.apiURL;
  readonly apiController = "/FaQs";
  BaseURI : string;
  formData : FaQModel;
  list : FaQModel[];


/*
  form: FormGroup = new FormGroup({
    faqId: new FormControl(null),
    faqNo: new FormControl(null),
    categoryId :  new FormControl(null),
    productId: new FormControl(null),
    issue: new FormControl('', Validators.required),
    solution: new FormControl('', Validators.required),
    createTime: new FormControl(''),
    createBy: new FormControl(''),
    });
*/
  form : FormGroup = FaQModel.getFormGroup();

  constructor(private http : HttpClient, private userservice : UserService) {
    console.log("constructor : FaqService ");
    this.BaseURI = window.location.origin + "/api";
  }

  populateForm(item) {

   this.form.setValue(item);
  }


 // postCustomerDetail(form : Customer)
  postDetail()
  {
     return this.http.post(this.BaseURI + this.apiController, this.formData);
  }

  putDetail()
  {
     return this.http.put(this.BaseURI + this.apiController + "/" + this.formData.faqId, this.formData);
  }

  getDetail(id)
  {
     return this.http.get(this.BaseURI + this.apiController + "/" + id);
  }

  refreshList()
  {

    return this.http.get(this.BaseURI + this.apiController).toPromise().then(
      res => {
        this.list = res as FaQModel[];

      }
    );
  }

  getList()
  {
     return this.http.get(this.BaseURI + this.apiController);
   // this.list = this.http.get(this.BaseURI + "/Customers");
    //return this.list.snapshotChanges();


  }

  insertData(item) {
    item.createBy = this.userservice.getUserID();
    return this.http.post(this.BaseURI + this.apiController, _.omit(item, ["faqId", "faqNo", "createTime"]));
  }

  updateData(item) {
    return this.http.put(this.BaseURI + this.apiController + "/" + item.faqId, item);
  }


  deleteData(id)
  {
    return this.http.delete(this.BaseURI + this.apiController + "/" + id);

  }

  findData(key)
  {
    return this.http.get(this.BaseURI + this.apiController + "/Find?keywords=" + key);
  }

  initializeFormGroup(){
    FaQModel.initializeFormGroup(this.form);
/*
    this.form.setValue({
      faqId : null,
      faqNo : 0,
      categoryId : null,
      productId : null,
      issue : null,
      solution : null,
      createTime : null,
      createBy : null

    });
  */
  }

  getFaqFileList(id)
    {

      return this.http.get(this.BaseURI + this.apiController + "/GetAttachedFileList?id=" + id);
   }
}
